export const genderOption = {
  MALE: 'male',
  FEMALE: 'female',
  NOTPROVIDED: 'notProvided',
  OTHER: 'other'
};

export const genderLocaleMap = {
  [genderOption.MALE]: 'male',
  [genderOption.FEMALE]: 'female',
  [genderOption.OTHER]: 'other',
  [genderOption.NOTPROVIDED]: 'notProvided'
};

export function getGenderOptions(localized) {
  return [
    {
      label: localized?.[genderLocaleMap[genderOption.MALE]] || 'Male',
      value: genderOption.MALE
    },
    {
      label: localized?.[genderLocaleMap[genderOption.FEMALE]] || 'Female',
      value: genderOption.FEMALE
    },
    {
      label: localized?.[genderLocaleMap[genderOption.NOTPROVIDED]] || 'Not provided',
      value: genderOption.NOTPROVIDED
    },
    {
      label: localized?.[genderLocaleMap[genderOption.OTHER]] || 'Other',
      value: genderOption.OTHER
    }
  ];
}
